export enum ETaskTypeDTO {
  Appointments = 'Appointments',
}

export enum ETaskStatusDTO {
  Opened = 'Opened',
  Active = 'Active',
  Closed = 'Closed',
}
